import React, { useCallback, useEffect } from 'react';
import c from 'classnames';
import ScrollableContent, { type ScrollableContentProps } from '@wix/da-ds/pkg/ScrollableContent';
import { useBodyScrollLock } from '@wix/da-ds/pkg/hooks/useBodyScrollLock';
import { setRefs } from '@wix/da-shared-react/pkg/utils/refHelpers';
import s from './FeedScrollableContainer.scss';

interface Props extends Omit<ScrollableContentProps, 'wrapperClassName'> {}

const FeedScrollableContainer: React.FC<Props> = ({
  children,
  innerRef: suppliedInnerRef,
  className,
  ...rest
}) => {
  const { onLock, onUnlock, setScrollableRef, scrollableElementRef } = useBodyScrollLock();

  useEffect(() => {
    return () => onUnlock();
  }, [onUnlock]);

  const innerRefCallback = useCallback(
    r => {
      if (!scrollableElementRef.current) {
        setScrollableRef(r);
        onLock();
      }
    },
    [onLock, scrollableElementRef, setScrollableRef]
  );
  return (
    <ScrollableContent
      className={c(s['scrollable'], className)}
      wrapperClassName={s['scrollable-wrapper']}
      innerRef={node => setRefs([innerRefCallback, suppliedInnerRef], node)}
      {...rest}
    >
      {children}
    </ScrollableContent>
  );
};

FeedScrollableContainer.displayName = 'FeedScrollableContainer';

export default FeedScrollableContainer;
